// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../react-forms/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../react-forms/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body.login-page-background {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-attachment: fixed;
  min-height: 100vh;
}

.container.login h1,
.container.login h2 {
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  font-weight: 300;
  margin-bottom: 40px;
}

.formWhite {
  background: rgba(255, 255, 255, 0.98);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  border: none;
  padding: 30px 10px;
}

.password_forgotten a {
  color: rgba(255, 255, 255, 0.85) !important;
  font-weight: 500;
  transition: all 0.2s;
}
.password_forgotten a:hover {
  color: white !important;
  text-decoration: underline;
}

.sign-in-form {
  position: relative;
  overflow: hidden;
  min-height: 320px;
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}
.sign-in-form .use-account-heading {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin: 0 0 20px 0;
}
.sign-in-form .password-forgotten-link {
  color: #888;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.2s ease;
}
.sign-in-form .password-forgotten-link:hover {
  color: #4CAF50;
  text-decoration: underline;
}
.sign-in-form .slide-container {
  position: relative;
  width: 100%;
}
.sign-in-form .slide-step {
  width: 100%;
  transition: transform 0.5s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.4s ease;
  will-change: transform, opacity;
}
.sign-in-form .slide-step.slide-enter {
  animation: slideInFromRight 0.5s cubic-bezier(0.25, 1, 0.5, 1) forwards;
}
.sign-in-form .slide-step.slide-exit {
  animation: slideOutToLeft 0.4s cubic-bezier(0.25, 1, 0.5, 1) forwards;
}
.sign-in-form .slide-step.slide-enter-reverse {
  animation: slideInFromLeft 0.5s cubic-bezier(0.25, 1, 0.5, 1) forwards;
}
.sign-in-form .slide-step.slide-exit-reverse {
  animation: slideOutToRight 0.4s cubic-bezier(0.25, 1, 0.5, 1) forwards;
}
.sign-in-form .input-field {
  margin-bottom: 20px;
}
.sign-in-form .input-field label {
  display: block;
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
  font-weight: 500;
}
.sign-in-form .checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  padding: 8px 0;
}
.sign-in-form .checkbox-wrapper input[type=checkbox] {
  appearance: none;
  width: 22px;
  height: 22px;
  border: 2px solid #ddd;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  background: white;
}
.sign-in-form .checkbox-wrapper input[type=checkbox]:checked {
  background: #4CAF50;
  border-color: #4CAF50;
}
.sign-in-form .checkbox-wrapper input[type=checkbox]:checked::after {
  content: "";
  position: absolute;
  top: 45%;
  left: 50%;
  width: 6px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: translate(-50%, -60%) rotate(45deg);
}
.sign-in-form .checkbox-wrapper label {
  font-size: 14px;
  color: #555;
  cursor: pointer;
  user-select: none;
}
.sign-in-form .btn-big {
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  padding: 16px 24px;
  border: none;
  border-radius: 12px;
  background: linear-gradient(135deg, #4CAF50 0%, #388E3C 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(76, 175, 80, 0.35);
  transition: all 0.3s ease;
  text-transform: none;
  letter-spacing: 0.3px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.sign-in-form .btn-big::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0));
  opacity: 0;
  transition: opacity 0.3s ease;
}
.sign-in-form .btn-big:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(76, 175, 80, 0.45);
}
.sign-in-form .btn-big:hover::after {
  opacity: 1;
}
.sign-in-form .btn-big:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
}
.sign-in-form .btn-big:disabled {
  background: #e0e0e0;
  box-shadow: none;
  color: #999;
  cursor: not-allowed;
  transform: none;
}
.sign-in-form .googleSignIn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 54px;
  background-color: white;
  border: 1px solid #dadce0;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
  gap: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}
.sign-in-form .googleSignIn:hover {
  background-color: #f8fbff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
  border-color: #cce0ff;
}
.sign-in-form .googleSignIn span {
  color: #3c4043;
  font-size: 16px;
  font-weight: 500;
  font-family: "Google Sans", "Roboto", sans-serif;
}
.sign-in-form .googleSignIn svg {
  width: 24px;
  height: 24px;
}
.sign-in-form .current-email {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: #f8f9fa;
  border-radius: 20px;
  border: 1px solid #e0e0e0;
  margin-bottom: 24px;
  color: #333;
  font-size: 15px;
  font-weight: 500;
}
.sign-in-form .current-email svg {
  width: 20px;
  height: 20px;
  color: #4CAF50;
  flex-shrink: 0;
}
.sign-in-form .back-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #777;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s ease;
  padding: 10px 16px;
  border-radius: 8px;
  margin-top: 8px;
}
.sign-in-form .back-link:hover {
  color: #333;
  background: #f0f0f0;
}
.sign-in-form .back-link svg {
  width: 16px;
  height: 16px;
}
.sign-in-form .alt-action-link {
  color: #4CAF50;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  padding: 10px 20px;
  border-radius: 8px;
  display: inline-block;
}
.sign-in-form .alt-action-link:hover {
  color: #388E3C;
  background: rgba(76, 175, 80, 0.08);
  text-decoration: none;
}
.sign-in-form .passkey-link-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.sign-in-form .passkey-link-with-icon .passkey-link-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.sign-in-form .divider-text {
  display: flex;
  align-items: center;
  text-align: center;
  color: #a0a0a0;
  font-size: 13px;
  margin: 24px 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 500;
}
.sign-in-form .divider-text::before, .sign-in-form .divider-text::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #eeeeee;
}
.sign-in-form .divider-text::before {
  margin-right: 16px;
}
.sign-in-form .divider-text::after {
  margin-left: 16px;
}
.sign-in-form .error-message {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #FEF2F2;
  border: 1px solid #FCA5A5;
  border-radius: 10px;
  padding: 14px 16px;
  color: #B91C1C;
  font-size: 14px;
  margin-top: 16px;
  box-shadow: 0 2px 6px rgba(185, 28, 28, 0.05);
}
.sign-in-form .error-message svg {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
.sign-in-form .loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 12px;
}

.passkey-enrollment-prompt {
  background: none;
  border-radius: 20px;
  padding: 32px 24px;
  text-align: center;
  margin-bottom: 20px;
  box-shadow: none;
  border: none;
}
.passkey-enrollment-prompt h3 {
  font-size: 20px;
  font-weight: 700;
  color: #111;
  margin: 0 0 12px 0;
}
.passkey-enrollment-prompt p {
  font-size: 15px;
  color: #555;
  margin: 0 0 28px 0;
  line-height: 1.6;
}
.passkey-enrollment-prompt .passkey-icon {
  width: 64px;
  height: 64px;
  background: linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px auto;
  color: #2E7D32;
}
.passkey-enrollment-prompt .passkey-icon svg {
  width: 32px;
  height: 32px;
}
.passkey-enrollment-prompt .skip-link {
  display: inline-block;
  margin-top: 20px;
  color: #999;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.passkey-enrollment-prompt .skip-link:hover {
  color: #555;
  background: #f5f5f5;
}

.tfa-code-input-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.tfa-code-input-container .tfa-code-inputs {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-bottom: 10px;
}
.tfa-code-input-container .tfa-code-inputs .tfa-code-digit {
  width: 45px;
  height: 55px;
  font-size: 24px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #fff;
  color: #333;
  transition: all 0.2s ease;
  padding: 0;
  margin: 0;
  font-family: "Inter", sans-serif;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  appearance: none;
  -moz-appearance: textfield;
}
.tfa-code-input-container .tfa-code-inputs .tfa-code-digit:focus {
  border-color: #4CAF50;
  box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.15);
  outline: none;
  transform: translateY(-1px);
}
.tfa-code-input-container .tfa-code-inputs .tfa-code-digit.error {
  border-color: #ef5350;
  background-color: #FFEBEE;
}
@media (max-width: 800px) {
  .tfa-code-input-container .tfa-code-inputs .tfa-code-digit {
    width: 36px;
    height: 48px;
    font-size: 18px;
  }
}
@media (max-width: 800px) {
  .tfa-code-input-container .tfa-code-inputs {
    gap: 5px;
  }
}

@keyframes slideInFromRight {
  from {
    transform: translateX(60px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slideOutToLeft {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-60px);
    opacity: 0;
  }
}
@keyframes slideInFromLeft {
  from {
    transform: translateX(-60px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slideOutToRight {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(60px);
    opacity: 0;
  }
}
.separator-10 {
  height: 10px;
}

.separator-15 {
  height: 15px;
}

.separator-20 {
  height: 20px;
}

.separator-25 {
  height: 25px;
}

/*# sourceMappingURL=sign-in-form.css.map */
`, "",{"version":3,"sources":["webpack://./../public/sass/sign-in-form.scss","webpack://./../public/css/sign-in-form.css"],"names":[],"mappings":"AAWA;EACI,6DAAA;EACA,4BAAA;EACA,iBAAA;ACVJ;;ADeI;;EAEI,YAAA;EACA,yCAAA;EACA,gBAAA;EACA,mBAAA;ACZR;;ADgBA;EACI,qCAAA;EACA,mBAAA;EACA,0CAAA;EACA,YAAA;EACA,kBAAA;ACbJ;;ADgBA;EACI,2CAAA;EACA,gBAAA;EACA,oBAAA;ACbJ;ADeI;EACI,uBAAA;EACA,0BAAA;ACbR;;ADkBA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iJAAA;ACfJ;ADiBI;EACI,eAAA;EACA,gBAAA;EACA,WAtDK;EAuDL,kBAAA;EACA,kBAAA;ACfR;ADkBI;EACI,WAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;AChBR;ADkBQ;EACI,cApEI;EAqEJ,0BAAA;AChBZ;ADqBI;EACI,kBAAA;EACA,WAAA;ACnBR;ADsBI;EACI,WAAA;EACA,2EAAA;EACA,+BAAA;ACpBR;ADsBQ;EACI,uEAAA;ACpBZ;ADuBQ;EACI,qEAAA;ACrBZ;ADwBQ;EACI,sEAAA;ACtBZ;ADyBQ;EACI,sEAAA;ACvBZ;AD4BI;EACI,mBAAA;AC1BR;AD4BQ;EACI,cAAA;EACA,eAAA;EACA,WAzGC;EA0GD,kBAAA;EACA,gBAAA;AC1BZ;AD+BI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;AC7BR;AD+BQ;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;AC7BZ;AD+BY;EACI,mBAtIA;EAuIA,qBAvIA;AC0GhB;AD+BgB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8CAAA;AC7BpB;ADkCQ;EACI,eAAA;EACA,WAtJC;EAuJD,eAAA;EACA,iBAAA;AChCZ;ADqCI;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,6DAAA;EACA,YAAA;EACA,8CAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ACnCR;ADqCQ;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,6EAAA;EACA,UAAA;EACA,6BAAA;ACnCZ;ADsCQ;EACI,2BAAA;EACA,8CAAA;ACpCZ;ADsCY;EACI,UAAA;ACpChB;ADwCQ;EACI,wBAAA;EACA,4CAAA;ACtCZ;ADyCQ;EACI,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;ACvCZ;AD2CI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,SAAA;EACA,yCAAA;ACzCR;AD2CQ;EACI,yBAAA;EACA,wCAAA;EACA,2BAAA;EACA,qBAAA;ACzCZ;AD4CQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gDAAA;AC1CZ;AD6CQ;EACI,WAAA;EACA,YAAA;AC3CZ;ADgDI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,WA/PK;EAgQL,eAAA;EACA,gBAAA;AC9CR;ADgDQ;EACI,WAAA;EACA,YAAA;EACA,cAxQI;EAyQJ,cAAA;AC9CZ;ADkDI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AChDR;ADkDQ;EACI,WAxRC;EAyRD,mBAAA;AChDZ;ADmDQ;EACI,WAAA;EACA,YAAA;ACjDZ;ADqDI;EACI,cArSQ;EAsSR,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;ACnDR;ADqDQ;EACI,cA9SG;EA+SH,mCAAA;EACA,qBAAA;ACnDZ;ADuDI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;ACrDR;ADuDQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;ACrDZ;ADyDI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;ACvDR;ADyDQ;EAEI,WAAA;EACA,OAAA;EACA,gCAAA;ACxDZ;AD2DQ;EACI,kBAAA;ACzDZ;AD4DQ;EACI,iBAAA;AC1DZ;AD8DI;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,6CAAA;AC5DR;AD8DQ;EACI,WAAA;EACA,YAAA;EACA,cAAA;AC5DZ;ADgEI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;AC9DR;;ADmEA;EACI,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,YAAA;AChEJ;ADkEI;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AChER;ADmEI;EACI,eAAA;EACA,WAhZK;EAiZL,kBAAA;EACA,gBAAA;ACjER;ADoEI;EACI,WAAA;EACA,YAAA;EACA,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,cAAA;AClER;ADoEQ;EACI,WAAA;EACA,YAAA;AClEZ;ADsEI;EACI,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;ACpER;ADsEQ;EACI,WAlbC;EAmbD,mBAAA;ACpEZ;;AD0EA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;ACvEJ;ADyEI;EACI,aAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;ACvER;ADyEQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBA1cJ;EA2cI,WA9cC;EA+cD,yBAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;EACA,yCAAA;EAGA,gBAAA;EACA,0BAAA;ACzEZ;AD2EY;EACI,qBA5dA;EA6dA,6CAAA;EACA,aAAA;EACA,2BAAA;ACzEhB;AD4EY;EACI,qBA7dF;EA8dE,yBA7dL;ACmZX;AD6EY;EA/BJ;IAgCQ,WAAA;IACA,YAAA;IACA,eAAA;EC1Ed;AACF;AD6EQ;EA5CJ;IA6CQ,QAAA;EC1EV;AACF;;AD+EA;EACI;IACI,2BAAA;IACA,UAAA;EC5EN;ED+EE;IACI,wBAAA;IACA,UAAA;EC7EN;AACF;ADgFA;EACI;IACI,wBAAA;IACA,UAAA;EC9EN;EDiFE;IACI,4BAAA;IACA,UAAA;EC/EN;AACF;ADkFA;EACI;IACI,4BAAA;IACA,UAAA;EChFN;EDmFE;IACI,wBAAA;IACA,UAAA;ECjFN;AACF;ADoFA;EACI;IACI,wBAAA;IACA,UAAA;EClFN;EDqFE;IACI,2BAAA;IACA,UAAA;ECnFN;AACF;ADuFA;EACI,YAAA;ACrFJ;;ADwFA;EACI,YAAA;ACrFJ;;ADwFA;EACI,YAAA;ACrFJ;;ADwFA;EACI,YAAA;ACrFJ;;AAEA,2CAA2C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
